import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const serviceLinks = [
    { labelKey: 'nav_solutions', path: '/solutions' },
    { labelKey: 'nav_infrastructure', path: '/infrastructure' },
    { labelKey: 'nav_security', path: '/security' },
    { labelKey: 'nav_cases', path: '/case-studies' },
  ];

  const companyLinks = [
    { labelKey: 'nav_about', path: '/about' },
    { labelKey: 'nav_contact_cta', path: '/contact' },
  ];

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="flex items-end gap-1">
                <div
                  className="relative flex items-baseline leading-none select-none"
                  style={{ fontFamily: "'Comfortaa', cursive" }}
                >
                  <span className="relative text-[36px] font-bold text-white leading-none">
                    <span
                      className="absolute text-[12px] font-bold text-cyan-400 leading-none"
                      style={{ top: '-7px', left: '50%', transform: 'translateX(-50%)' }}
                    >
                      °
                    </span>
                    a
                  </span>
                  <span className="text-[36px] font-bold text-white leading-none">b</span>
                </div>
                <div className="flex flex-col leading-none ml-1.5 pb-[1px]">
                  <span className="text-white font-bold text-sm tracking-wide">A<span className="text-cyan-400">&amp;</span>B</span>
                  <span className="text-slate-400 text-xs tracking-widest font-medium">SYSTEM</span>
                </div>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-sm mb-6">
              {t('footer_desc')}
            </p>
            <div className="flex items-center gap-2 text-slate-400 text-sm mb-6">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-mail-line text-cyan-400"></i>
              </div>
              info@absystemthai.com
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm tracking-wider uppercase">
              {t('footer_services_heading')}
            </h4>
            <ul className="space-y-3">
              {serviceLinks.map(l => (
                <li key={l.path}>
                  <Link to={l.path} className="text-slate-400 hover:text-cyan-400 text-sm transition-colors cursor-pointer">
                    {t(l.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm tracking-wider uppercase">
              {t('footer_company_heading')}
            </h4>
            <ul className="space-y-3">
              {companyLinks.map(l => (
                <li key={l.path}>
                  <Link to={l.path} className="text-slate-400 hover:text-cyan-400 text-sm transition-colors cursor-pointer">
                    {t(l.labelKey)}
                  </Link>
                </li>
              ))}
            </ul>

            <div className="mt-8">
              <h4 className="text-white font-semibold mb-3 text-sm">{t('footer_hours_title')}</h4>
              <p className="text-slate-400 text-xs leading-relaxed">
                {t('footer_hours_weekday')}<br />
                {t('footer_hours_emergency')}
              </p>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">{t('footer_copyright')}</p>
          <div className="flex items-center gap-2 text-slate-500 text-xs">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shield-check-fill text-cyan-500"></i>
            </div>
            {t('footer_security')}
          </div>
        </div>
      </div>
    </footer>
  );
}
